import { IconNames } from "app/shared/models/icon-names.interface";

export const O2_ICONS: Partial<IconNames> = {
  add: "icon_add_solid_black",
  address_book: "icon_address_book_solid_black",
  call: "icon_call_solid",
  call_drop_area: "icon_call_drop_area",
  call_modal: "icon_call_modal_solid",
  contact_call: "icon_contact_call",
  calendar_outline: "icon_calendar_outline_black",
  call_forwarding: "icon_call_forwarding_solid_black",
  call_outgoing: "icon_call_outgoing_solid_black",
  call_incoming: "icon_call_incoming_solid_black",
  call_missed: "icon_call_missed_solid_black",
  call_round: "icon_call_solid",
  cdr: "icon_cdr_solid",
  close: "icon_close_solid_black",
  conference_call_outline: "icon_conference_call_solid",
  conference_call_solid: "icon_conference_call_solid_black",
  contact: "icon_contact_solid_black",
  delete: "icon_delete_solid_black",
  dialpad: "icon_dialpad_solid_black",
  download: "icon_download_solid_black",
  duplicate: "icon_duplicate_solid_black",
  edit: "icon_edit_solid_black",
  extension: "icon_extension_solid_black",
  fax_outline: "icon_fax_solid",
  fax_solid: "icon_fax_solid_black",
  filter: "icon_filter_solid",
  lock_closed: "icon_lock_closed_solid_black",
  lock_open: "icon_lock_open_solid_black",
  logout: "icon_logout_solid_black",
  mic_off: "icon_mic_off_solid_black",
  mic_on: "icon_mic_on_solid_black",
  pause: "icon_pause_solid_black",
  queue: "icon_queues_solid_black",
  settings_outline: "icon_settings_solid_black",
  settings_solid: "icon_settings_solid_black",
  time: "icon_time_solid_black",
  transfer: "icon_transfer_solid_black",
};
